import { useSuspenseQuery } from '@tanstack/react-query';
import { GatheringSpot } from '@outdoria/types';
import { fetcher } from '../utils';
import { GATHERING_SPOT } from '../queryKeys';

export const useGetGatheringSpotById = (gathering_spot_id?: string) => {
  const queryFn = async (): Promise<GatheringSpot> => {
    const res = await fetcher(`/v2/gathering_spots/${gathering_spot_id}`);
    return res.json();
  };

  const { data, isLoading, isFetched, isError } = useSuspenseQuery<
    GatheringSpot,
    unknown,
    GatheringSpot,
    string[]
  >({
    queryKey: [...GATHERING_SPOT, gathering_spot_id!],
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
